import React, {useState} from "react";
import {Page} from "../../components/page/page";
import styles from "./analyzing-profile.module.css";
import {useNavigate} from "react-router-dom";
import Stars from "../../images/reviewStars.png"

const AnalyzingProfilePage = () => {

    const navigate = useNavigate();

    const [birthChatProgress, setBirthChatProgress] = useState(0);
    const [relationshipProgress, setRelationshipProgress] = useState(0);
    const [talentsProgress, setTalentsProgress] = useState(0);

    setTimeout(() => {
        if (birthChatProgress < 100)
            setBirthChatProgress(birthChatProgress + 1);
    }, 30);

    setTimeout(() => {
        if (birthChatProgress >= 100 && relationshipProgress < 100)
            setRelationshipProgress(relationshipProgress + 1);
    }, 30);

    setTimeout(() => {
        if (birthChatProgress >= 100 && relationshipProgress >= 100 && talentsProgress < 100)
            setTalentsProgress(talentsProgress + 1);
    }, 30);

    if (birthChatProgress >= 100 && relationshipProgress >= 100 && talentsProgress >= 100 ) {
        setTimeout(() => navigate("../result"), 500);
    }

    const headerStyles = {
        backgroundColor: "transparent",
        borderBottom: "none",
        boxShadow: "none"
    }

    return (
        <div className={styles.container_page}>
            <Page title="Analyzing your profile..." hideContinueButton={true} hideSteps={true} headerStyles={headerStyles} isWhiteLogo={true}>
                <div>
                    <div className={styles.line_title}>
                        <p>✨ Analyzing your birth chart</p>
                        <p>{birthChatProgress}%</p>
                    </div>
                    <progress
                        value={birthChatProgress}
                        max={100}
                        className={styles.progress_future}
                    ></progress>
                </div>
                <div>
                    <div className={styles.line_title}>
                        <p>👫 Creating relationship guidance</p>
                        <p>{relationshipProgress}%</p>
                    </div>
                    <progress
                        value={relationshipProgress}
                        max={100}
                        className={styles.progress_future}
                    ></progress>
                </div>
                <div>
                    <div className={styles.line_title}>
                        <p>🤸 Identifying your talents & strengths</p>
                        <p>{talentsProgress}%</p>
                    </div>
                    <progress
                        value={talentsProgress}
                        max={100}
                        className={styles.progress_future}
                    ></progress>
                </div>

                <div className={styles.review_container}>
                    <img src={Stars} alt=""/>
                    <div className={styles.name_container}>
                        <h6 className={styles.review_title}>Thank you</h6>
                        <p className={styles.author_name}>monamonamo</p>
                    </div>
                    <p className={styles.review_text}>Having my Venus in the 12th house explained a lot about my difficult love life.</p>
                </div>
            </Page>
        </div>
    )
};

export {AnalyzingProfilePage};
